import merge from 'deepmerge';
import { bridgeUserAttributesToElevar } from './elevar/bridge.ts';
import { toStr } from './elevar/helpers.ts';
import { startTrackingEvents } from './trackingStatus.ts';
import gtmDataLayer from './gtmDataLayer.ts';
import { pick, isEmpty } from './utils.ts';
import {
    getInitialInfoFiredState,
    setInitialInfoFiredState,
    getInitialPageviewFiredState,
} from './gtmStatus.ts';
import { getGtmPageInfo } from './gtmPageInfo.ts';
import { eventTypeConstants } from './constants.ts';

import { type UserAttributes } from './types.ts';

export const gtmUserAttributeKeys = [
    'loginStatus',
    'registrationStatus',
    'userID',
    'guestID',
    'userEmail',
    'userEmailAddress',
    'sha256UserEmail',
    'emailToken',
    'userZip',
    'defaultCurrency',
    'contactDealerStatus',
    'buyerStatus',
    'tradeStatus',
    'customerType',
    'tradeTier',
    'tradeFirmId',
    'profileStatus',
    'tradeRewardStatus',
    'registrationDate',
    'incomeRange',
    'currentAccountType',
    'activePromotion',
    'name',
    'line1',
    'line2',
    'city',
    'state',
    'country',
    'zipCode',
    'isPadDevice',
    'isGdprApplicable',
];

/**
 * pushes userAttributes into the dataLayer (along with the gtmPageInfo)
 * @param trackObj
 */
export function addUserAttributes(trackObj: UserAttributes): void {
    if (!isEmpty(trackObj) && !getInitialInfoFiredState()) {
        // filters out invalid userAttribute keys
        const gtmUserAttributes = pick(trackObj, gtmUserAttributeKeys);
        // ElevarUserIdFn must be defined before the GTM Browser Setup snippet runs.
        // https://dev.getelevar.com/guides/api/browser-setup/user-id
        const userId = toStr(trackObj.userID) ?? toStr(trackObj.guestID) ?? '';
        window.ElevarUserIdFn = () => userId;

        // need to ignore `merge.all` signature otherwise following TS error is thrown:
        // error TS2345: Argument of type 'object' is not assignable to parameter of type 'Record<string, unknown>'.
        // Index signature is missing in type '{}'.
        // @ts-ignore
        // pushing the initial dataLayerInfo directly to the dataLayer
        gtmDataLayer.push(
            merge.all([
                { event: eventTypeConstants.EVENT_USER_TRACKING_READY },
                gtmUserAttributes,
                getGtmPageInfo(),
            ])
        );
        setInitialInfoFiredState(true);

        bridgeUserAttributesToElevar(trackObj);

        // if the pageView has not been fired then we want to wait for it to be fired to start tracking events
        if (getInitialPageviewFiredState()) {
            startTrackingEvents();
        }
    }
}
